// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__23HV1","errorLogs":"EditorFooter_errorLogs__2gsR8"};